import script from "./TheToolTip.vue?vue&type=script&setup=true&lang=js"
export * from "./TheToolTip.vue?vue&type=script&setup=true&lang=js"

import "./TheToolTip.vue?vue&type=style&index=0&id=1d294820&lang=css"

const __exports__ = script;

export default __exports__